import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Nav, Card, Row, Col } from 'react-bootstrap';
import RawMaterials from 'components/pages/haccp/monitoring/common/page/tab/RawMaterials';
import Products from 'components/pages/haccp/monitoring/common/page/tab/Products';
import Process from 'components/pages/haccp/monitoring/common/page/tab/Process';

// hooks
import useHistoryState from 'hooks/useHistoryState';

const View = () => {
  /* router info */
  const { state } = useLocation();

  /* state */
  const [pltCd] = useState('A120'); // 공장코드
  const [productCode] = useState('prdt'); // 제품코드
  const [rawMaterialCode] = useState('rwmtr'); // 원료코드
  const [processCode, setProcessCode] = useState('proc'); // 공정코드
  const [baseYm, setBaseYm] = useHistoryState(new Date(), 'baseYm'); // 조회월
  const [tab, setTab] = useHistoryState(0, 'tab');
  const [tabsList, setTabsList] = useState([
    {
      name: '제품',
      tabIndex: 0
    },
    {
      name: '원료',
      tabIndex: 1
    }
  ]);

  /* watch */
  useEffect(() => {
    setTabsList([
      {
        name: '제품',
        tabIndex: 0
      },
      {
        name: '원료',
        tabIndex: 1
      },
      {
        name: '공정',
        tabIndex: 2
      }
    ]);
  }, []);

  useEffect(() => {
    setBaseYm(new Date());
  }, [tab]);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="align-items-center g-2">
            <Col>
              <h5 className="mb-0">군산공장 모니터링</h5>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Nav variant="tabs" defaultActiveKey={`link-${tab}`} key={tab}>
            {tabsList?.map(({ name, tabIndex }, index) => (
              <Nav.Item key={index}>
                <Nav.Link
                  eventKey={`link-${tabIndex}`}
                  onClick={() => setTab(tabIndex)}
                >
                  {name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          {/* 제품 */}
          {tab === 0 && (
            <Products
              tab={tab}
              pltCd={pltCd}
              ctgryGrpCd={productCode}
              baseYm={baseYm}
            ></Products>
          )}
          {/* 원료 */}
          {tab === 1 && (
            <RawMaterials
              tab={tab}
              pltCd={pltCd}
              ctgryGrpCd={rawMaterialCode}
              baseYm={baseYm}
            ></RawMaterials>
          )}
          {/* 공정 */}
          {tab === 2 && (
            <Process
              tab={tab}
              pltCd={pltCd}
              ctgryGrpCd={processCode}
              baseYm={baseYm}
            ></Process>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default View;
